import React from 'react';
import './Header.css';
import Typography from '@material-ui/core/Typography';

const Header = (props) => {

   
    
    return (
        <div className="header" >      
          <Typography variant="h5" color="secondary">{props.title}</Typography>
      </div>
    );
}

export default Header;